import Vue from 'vue';
import Clipboard from 'clipboard'
// const language = window.localStorage.getItem('lang');
// let successMsg, errorMsg;
// if(language == 'cn') {
//   successMsg = '复制成功！';
//   errorMsg = '复制失败！';
// }else {
//   successMsg = 'Copy successfully!';
//   errorMsg = 'Copy failed!';
// }

export default function handleClipboard(event, text, succFn, failFn) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    clipboard.destroy()
    if(!succFn) {
      Vue.prototype.$message({
        message: '复制成功！',
        type: 'success',
        duration: 1500
      })
    }else {
      succFn();
    }
  })
  clipboard.on('error', () => {
    clipboard.destroy()
    if(!failFn) {
      Vue.prototype.$message({
        message: '复制失败！',
        type: 'error'
      })
    }else {
      failFn();
    }
  })
  clipboard.onClick(event)
}